import React from "react";
import { motion } from "framer-motion";
import telegramService from "../utils/telegram";

interface ReminderRowProps {
  label: string;
  enabled: boolean;
  time: string;
  onToggle: (enabled: boolean) => void;
  onTimeChange: (time: string) => void;
}

const ReminderRow: React.FC<ReminderRowProps> = ({ label, enabled, time, onToggle, onTimeChange }) => {
  const handleToggle = () => {
    telegramService.haptic("selection");
    onToggle(!enabled);
  };

  return (
    <div className="p-4 border-b border-line last:border-0">
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold text-content-primary">{label}</span>
        <button
          onClick={handleToggle}
          className={`relative w-11 h-6 rounded-full transition-colors duration-200 ${
            enabled ? "bg-success" : "bg-line-strong"
          }`}
        >
          <motion.div
            animate={{ x: enabled ? 20 : 2 }}
            transition={{ type: "spring", stiffness: 500, damping: 30 }}
            className="absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm"
          />
        </button>
      </div>

      {enabled && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="mt-2"
        >
          <input
            type="time"
            value={time}
            onChange={(e) => onTimeChange(e.target.value)}
            className="w-full px-3 py-2 rounded-lg border border-line-strong text-sm font-medium text-content-primary bg-inset focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-500/30"
          />
        </motion.div>
      )}
    </div>
  );
};

export default ReminderRow;
